import DapGridController from './dap-grid.controller';

export default {
	template: require('./dap-grid.html'),
	controller: DapGridController
};
